import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=74198faf&scoped=true&lang=html&"
import script from "./CopyButton.vue?vue&type=script&lang=js&"
export * from "./CopyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74198faf",
  null
  
)

export default component.exports